import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import Styles from './style.module.scss';
import withComponentName from '../../../../../../../decorators/withComponentName';
import detailedActive from '../../../../../../../assets/api_pricing/detailed_active.svg';
import detailedInactive from '../../../../../../../assets/api_pricing/detailed_inactive.svg';
import columnActive from '../../../../../../../assets/api_pricing/column_active.svg';
import columnInActive from '../../../../../../../assets/api_pricing/column.svg';

const cx = classNames.bind(Styles);

export const PricingPlansFilterLayoutButton = ({
  isActive, btnText, handleBtnClick, btnID,
}) => (
  <button
    id={btnID}
    type="button"
    className={cx('PricingPlans__filterBtn', { active: isActive })}
    onClick={() => handleBtnClick(btnID)}
  >
    {btnID.toLowerCase() === 'detailed'
      && (
        <i className={cx('icon', { active: isActive })}>
          <img src={isActive ? detailedActive : detailedInactive} alt="detailed" />
        </i>
      )}
    {btnID.toLowerCase() === 'column'
      && (
        <i className={cx('icon', { active: isActive })}>
          <img src={isActive ? columnActive : columnInActive} alt="column" />
        </i>
      )}
    {btnText}
  </button>
);

PricingPlansFilterLayoutButton.propTypes = {
  isActive: PropTypes.bool.isRequired,
  btnText: PropTypes.string.isRequired,
  btnID: PropTypes.string.isRequired,
  handleBtnClick: PropTypes.func.isRequired,
};

export default withComponentName(PricingPlansFilterLayoutButton);
